import { fetchFromWebApi } from "../utils/fetchFromWebApi";

export const fetchAllRegistrations = async () => {
    try {
        const res = await fetchFromWebApi(
            `registration/GetAll`,
            {
                method: "GET",
            }
        );
        if (res?.ok) {
            const result = await res.json();
            return result;
        } else {
            console.error("Failed to fetch form elements:", await res.text());
        }
    } catch (error) {
        console.error("Error while fetching form elements:", error);
    }
};

export const updateRegistration = async (item) => {
    try {
        const res = await fetchFromWebApi(
            `registration/Update`,
            {
                method: "POST",
                body: JSON.stringify({ item: item }),
            }
        );
        if (res?.ok) {
            const result = await res.json();
            return result;
        } else {
            console.error("Failed to fetch form elements:", await res.text());
        }
    } catch (error) {
        console.error("Error while fetching form elements:", error);
    }
};